import { InfiniteZoom } from "./classes/infinite-zoom";
import { InfiniteZoomSettings } from "./classes/infinite-zoom-settings";

export function init(params?:any)
{
    params = params ? params : {};

    // Initialize script in selected elements
    let selector = params.hasOwnProperty('selector') ? params.selector : "zoomcontainer";
    let elements:HTMLCollectionOf<Element> = document.getElementsByClassName(selector);

    for (let i = 0; i < elements.length; i++)
    {
        let el:HTMLElement = elements.item(i) as HTMLElement;
        
        let settings = new InfiniteZoomSettings();
        settings.fill(params);

        // get settings from element
        if (el.dataset.hasOwnProperty("zoom"))
        {
            let obj:any = JSON.parse(el.dataset["zoom"]);
            if (obj)
            {
                settings.fill(obj);
            }            
        }
        InfiniteZoom.all.push(new InfiniteZoom(el, settings));
    }
}

export function close()
{
    InfiniteZoom.all[0].close();
}